export const PATHS = {
  auth: {
    login: '/login',
    magicLink: '/login/magic-link',
    otp: '/otp',
    resetPassword: '/redefinir-senha',
  },
  consolidator: {
    comparator: '/minha-carteira/comparador',
    index: '/meu-open-finance',
  },
  custom: {
    index: '/custom',
  },
  event: {
    index: '/eventos',
  },
  financialPlanning: {
    immobilized: '/planejamento-financeiro/imobilizado',
    index: '/planejamento-financeiro',
    myGoals: '/planejamento-financeiro/meus-objetivos',
    myRetirement: '/planejamento-financeiro/minha-aposentadoria',
    myWealth: '/planejamento-financeiro/meu-patrimonio',
    financialControl: '/planejamento-financeiro/controle-financeiro',
    report: '/planejamento-financeiro/relatorio',
  },
  home: '/',
  hubs: {
    advisory: '/minha-carteira-eqi',
    author: '/autor',
    content: '/conteudo',
    courses: '/cursos',
    hubRV: '/eqi-trader',
    movies: '/filmes',
    privatePension: '/minha-previdencia',
    program: '/programa',
    recommendation: '/ativos-recomendados',
    research: '/research',
    researchProgram: '/research/programa',
    finances: '/minhas-financas',
    contents: '/conteudos',
  },
  investments: {
    index: '/investimentos',
  },
  lp: {
    business: '/empresarial',
    creditCard: '/cartao-de-credito',
    exchange: '/cambio',
    goodsAcquisiton: '/aquisicao-de-bens',
    lifeInsurance: '/seguro-vida',
    rvAdvisory: '/assessoria-renda-variavel',
    riCalculator: '/calculadora-viver-de-renda',
    riCalculatorSimulation: '/calculadora-viver-de-renda/simulacao',
  },
  news: {
    index: '/noticias',
  },
  profile: {
    register: '/cadastro',
    updateData: '/atualizar-dados',
  },
  search: '/busca',
  user: {
    myHistoric: '/meu-historico',
    myList: '/minha-lista',
    profile: '/meu-perfil',
  },
  live: {
    index: '/live',
  },
  welcome: '/bem-vindo',
  embed: {
    retirementChart: '/embed-retirement-chart',
  },
};
